package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminUserListItem
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class UsersState(
    val statusFilter: String = "All",
    val search: String = "",
    val page: Int = 1,
    val totalPages: Int = 1,
    val totalCount: Long = 0L,
    val data: AsyncSection<List<AdminUserListItem>> = AsyncSection.Loading,
    val sortBy: String? = null,
    val sortAsc: Boolean = false,
) : MVIState

val USER_STATUS_FILTERS = listOf("All", "ACTIVE", "WARNED", "SUSPENDED", "BANNED")

sealed interface UsersIntent : MVIIntent {
    data class SetStatusFilter(val value: String) : UsersIntent
    data class SetSearch(val value: String) : UsersIntent
    data class GoToPage(val page: Int) : UsersIntent
    data class TapUser(val id: String) : UsersIntent
    data class ReactToFocusTick(val tick: Long) : UsersIntent
    data object Refresh : UsersIntent
    data class SetSort(val sortBy: String, val sortAsc: Boolean) : UsersIntent
}

sealed interface UsersAction : MVIAction {
    data class Navigate(val path: String) : UsersAction
}
